import React, { useState } from 'react';

import { LocateProductResponse } from '@apis/manageInventory/LocateProduct.type';
import { EmptyState } from '@atoms/emptyState/EmptyState';
import { Table as AntTable } from '@atoms/table/Table';
import sslsTableStyles from '@organisms/locateProducts/SslsTable.module.less';

import { PartsTable } from './PartsTable';

export interface SslTableProps {
    locateProductResponse?: LocateProductResponse;
    isLoading: boolean;
}

const columns = [
    {
        title: 'Warehouse',
        dataIndex: 'code',
        key: 'code'
    },
    {
        title: 'City',
        dataIndex: 'city',
        key: 'city'
    },
    {
        title: 'Country',
        dataIndex: 'country',
        key: 'country'
    }
];

export const SslTable = ({
    locateProductResponse,
    isLoading
}: SslTableProps) => {
    const [expandedRowId, setExpandedRowId] = useState('');

    const ssls = locateProductResponse?.data?.ssls
        ? [...locateProductResponse?.data?.ssls]
              .sort(
                  (a, b) =>
                      (a.country ?? '').localeCompare(b.country ?? '') ||
                      (a.city ?? '').localeCompare(b.city ?? '') ||
                      (a.province ?? '').localeCompare(b.province ?? '')
              )
              .map((ssl) => {
                  return {
                      id: ssl.code,
                      ...ssl,
                      city: ssl.province
                          ? ssl.city + ', ' + ssl.province
                          : ssl.city
                  };
              })
        : [];

    if (ssls.length === 0 && expandedRowId) {
        setExpandedRowId('');
    }

    return (
        <AntTable
            columns={columns}
            dataSource={ssls}
            isLoading={isLoading}
            expandable={{
                expandedRowRender: (ssl) => (
                    <PartsTable locateProductParts={ssl.parts} />
                ),
                onExpand: (_, row) =>
                    expandedRowId === row.id
                        ? setExpandedRowId('')
                        : setExpandedRowId(row.id),
                expandedRowKeys: [expandedRowId]
            }}
            expandClassName={sslsTableStyles.ExpandIcon}
            locale={
                locateProductResponse !== undefined &&
                ssls.length === 0 &&
                !isLoading
                    ? {
                          emptyText: (
                              <EmptyState
                                  title="No matching items found"
                                  subtitle="Try changing the search criteria"
                              />
                          )
                      }
                    : undefined
            }
        ></AntTable>
    );
};
